import React, { useEffect, useState } from 'react';
import styles from './GenericInfo.module.css';
import { IconButton, MenuItem, Select } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import ConvertLeadToProject from '../leads/convertToProject.component';
import Swal from 'sweetalert2';
import { updateLead, setAllLeads } from '../../Redux/Leads/leadsAction';
import { Provider } from 'react-redux';
import store from '../../Redux/Store';
import { convertToCustomer, getAllLeads } from '../../api/leads.api';
import { Lead } from '../../model/leads.model';
import { Enum } from '../../model/enum.model';
import withReactContent from 'sweetalert2-react-content';
import { getAllEnumFromServer } from '../../api/enum.api';
import { setAllStatusLeads } from '../../Redux/enum/statusLeadAction';
import DeleteIcon from '@mui/icons-material/Delete';
import ReactDOM from 'react-dom';
export interface InfoField {
  label: string;
  value: any;
  fieldName?: string;
  editType?: 'text' | 'icon-select' | 'status-select' | 'date' | 'number';
  options?: { value: string; label?: string; icon?: React.ReactNode }[];
}

interface GenericInfoProps {
  title?: string;
  fields: InfoField[];
  onFieldsUpdate?: (updatedFields: InfoField[]) => void;
  onSubmit: (updatedObject: any) => void;
  onDelete?: (projectId: string) => void
  setRef?: React.Dispatch<React.SetStateAction<boolean>>;
  id?: string
  fieldsContainerClassName?: string;
  columns?: number;
  dataType?: 'lead' | 'customer' | 'project';
}

const GenericInfo: React.FC<GenericInfoProps> = ({ title, columns, fields, onFieldsUpdate, onSubmit, fieldsContainerClassName, onDelete, id, dataType }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedValues, setEditedValues] = useState<{ [key: string]: any }>({});
  const statuses = useSelector((state: any) => state.taskStatus.allTaskStatus);
  const [selectedLeadId, setSelectedLeadId] = useState<string | null>(null);
  const [leads, setLeads] = useState<Lead[]>([]);
  const [statusOptions2, setStatusOptions2] = useState<Enum[]>([]);
  const [balanceStatusOptions, setBalanceStatusOptions] = useState<Enum[]>([]);
  const MySwal = withReactContent(Swal);
  const dispatch = useDispatch();
  const leadsState = useSelector((state: { leads: { allLeads: { [key: string]: Lead[] } } }) => state.leads);
  const leadStatus = useSelector((state: { statusLead: { allStatusLead: { [key: string]: Enum[] } } }) => state.statusLead);
  const [statusOptions, setStatusOptions] = useState<Enum[]>([]);
  const [leadsChanges, setLeadsChanges] = useState<boolean[]>();


  // עדכון הערכים הערוכים כאשר fields משתנים או כאשר נכנסים למצב עריכה
  useEffect(() => {
    const initialValues: { [key: string]: any } = {};

    fields.forEach((field) => {
      if (field.fieldName) {
        if (field.fieldName === 'status') {
          const defaultStatus = statuses.find((status) => status.value === field.value);
          initialValues[field.fieldName] = defaultStatus || { id: '', value: field.value, label: field.value }; // 🔹 שומר אובייקט מלא
        } else {
          initialValues[field.fieldName] = field.value;
        }
      }
    });
    console.log(fields,"ttt");

    console.log("📌 initialValues אחרי עיבוד:", initialValues);
    setEditedValues(initialValues);
  }, [fields, statuses]);



  useEffect(() => {
    const fetchData = async () => {
      try {
        let data;
        console.log(leadsState.allLeads);
        if (leadsState.allLeads.length) {
          data = leadsState.allLeads;
        } else {
          const resAllLeads = await getAllLeads();
          data = resAllLeads.data.map((lead: any) => ({
            ...lead,
            createdDate: new Date(lead.createdDate),
            lastContacted: lead.lastContacted ? new Date(lead.lastContacted) : null,
          }));

          dispatch(setAllLeads(data.reverse()));
        }
        setLeads(data);
        setLeadsChanges(new Array(data.length).fill(false));
      } catch (error) {
        console.error('Error fetching leads:', error);
      }
    };
    const fetchEnums = async () => {
      try {
        const statusEnums = await getAllEnumFromServer(3);
        const balanceStatusEnums = await getAllEnumFromServer(2);
        console.log(statusEnums);
        console.log(balanceStatusEnums);
        setStatusOptions2(statusEnums);
        setBalanceStatusOptions(balanceStatusEnums);
      } catch (error) {
        console.error('Error fetching enums:', error);
      }
    };

    const fetchStatusEnums = async () => {
      try {
        let data;
        console.log("Current status lead state:", leadStatus.allStatusLead);
        if (leadStatus.allStatusLead.length) {
          data = leadStatus.allStatusLead;
        } else {
          data = await getAllEnumFromServer(5);
        }
        console.log("Data to dispatch:", data);
        dispatch(setAllStatusLeads(data));
        setStatusOptions(data);
        console.log("Updated status lead state:", leadStatus.allStatusLead);
      } catch (error) {
        console.error('Error fetching leads:', error);
      }
    };
    setSelectedLeadId(fields[0].value)
    fetchStatusEnums(); fetchEnums(); fetchData();

  }, [dispatch]);

  const handleChange = (fieldName: string, selectedValue: string) => {
    const field = fields.find((f) => f.fieldName === fieldName);
    const selectedOption = field?.options?.find((opt) => opt.value === selectedValue);

    setEditedValues((prev) => ({
      ...prev,
      [fieldName]: fieldName === 'status' ? selectedOption : selectedValue,
    }));
  };
  const convertToInputDateValue = (dateValue: any): string => {
    if (!dateValue) return '';
    let dateObj: Date;
    if (typeof dateValue === 'string') {
      dateObj = new Date(dateValue);
    } else if (dateValue instanceof Date) {
      dateObj = dateValue;
    } else {
      return '';
    }
    if (isNaN(dateObj.getTime())) return '';
    return dateObj.toISOString().split('T')[0]; // yyyy-mm-dd  
  };
  const convertFromInputDateValue = (yyyymmdd: string): string => {
    if (!yyyymmdd || typeof yyyymmdd !== 'string') return '';
    const parts = yyyymmdd.split('-');
    if (parts.length !== 3) return '';
    const [year, month, day] = parts;
    if (!day || !month || !year) return '';
    return `${day}/${month}/${year}`;
  };

  const handleConvertLeadToProject = async () => {
    const result = await Swal.fire({
      title: '?האם אתה בטוח',
      text: "?האם אתה בטוח שאתה רוצה להמיר את הליד לפרויקט",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'כן!, המיר לפרויקט',
      cancelButtonText: 'ביטול',
      customClass: {
        confirmButton: 'button1',
        cancelButton: 'button1'
      }
    });
  console.log(selectedLeadId,"gggg");
    const lead = leads.find(lead => lead.id === selectedLeadId.toString());
    console.log(lead,"kkkkk");
    if (lead) {

      try {

        await convertToCustomer(String(selectedLeadId));

        Swal.fire({
          title: 'יצירת פרויקט חדש',
          html: '<div id="convert-lead-container"></div>',
          showCloseButton: true,
          showCancelButton: false,
          showConfirmButton: false,
          didOpen: () => {
            const container = document.getElementById('convert-lead-container');
            if (container) {
              ReactDOM.render(
                <Provider store={store}>
                  <ConvertLeadToProject
                    lead={lead!}
                    statusOptions2={statusOptions2}
                    balanceStatusOptions={balanceStatusOptions}
                    setLeads={setLeads}
                    handleProjectAdded={(newProject) => {
                      MySwal.fire({
                        title: 'success',
                        text: 'הפרויקט נוצר בהצלחה',
                        icon: 'success',
                        confirmButtonText: 'אישור',
                        customClass: {
                          confirmButton: 'my-confirm-button'
                        }
                      });

                    }}
                  />
                </Provider>,
                container
              );
            }
          },
        });
      }
      catch (error) {
        console.error('שגיאה בהמרת ליד ללקוח:', error);
        Swal.fire({
          title: 'שגיאה',
          text: 'אירעה שגיאה בהמרת הליד ללקוח',
          icon: 'error',
          confirmButtonText: 'סגור'
        });
      }
    }

  };

  const handleSubmit = async () => {
    

    try {
      console.log('Submit clicked. Edited values:', editedValues);

      if (onFieldsUpdate) {
        const updatedFieldObjects = fields.map((field) => ({
          ...field,
          value: editedValues[field.fieldName || ''] ?? field.value,
        }));
        console.log('Calling onFieldsUpdate with:', updatedFieldObjects);
        onFieldsUpdate(updatedFieldObjects);
      }

      const fullValues: { [key: string]: any } = {};
      fields.forEach((field) => {
        if (field.fieldName) {
          let value = editedValues[field.fieldName] ?? field.value;
          fullValues[field.fieldName] = value;
        }
      });

      console.log('Calling onSubmit with:', fullValues);
      await onSubmit(fullValues);
      setIsEditing(false);
    } catch (err) {
      console.error('שגיאה בעדכון הנתונים:', err);
    }
  };


  // פונקציה לביטול העריכה
  const handleCancel = () => {
    // החזרת הערכים למצב המקורי
    const initialValues: { [key: string]: any } = {};
    fields.forEach((field) => {
      if (field.fieldName) {
        initialValues[field.fieldName] = field.value;
      }
    });
    setEditedValues(initialValues);
    setIsEditing(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.titleRow}>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.actions}>
          {onDelete && (
            <IconButton onClick={() => onDelete(id)} title="מחיקה">
              <DeleteIcon style={{ color: 'red' }} />
            </IconButton>

          )}
          {!isEditing ? (
            <IconButton onClick={() => setIsEditing(true)}>
              <EditIcon />
            </IconButton>
          ) : (
            <>
              <IconButton onClick={handleSubmit}>
                <SaveIcon />
              </IconButton>
              <IconButton onClick={handleCancel}>
                <CloseIcon />
              </IconButton>
            </>
          )}
          {
            dataType === 'lead' && (
              <button className="convert-lead-button" onClick={handleConvertLeadToProject}>
                →
                <span className='add' style={{ fontSize: 15, color: '#636363' }}>המרת ליד ללקוח</span>
              </button>)
          }
        </div>
      </div>
      <div className={`${styles.grid} ${fieldsContainerClassName || ''}`}>
        {fields.map((field, index) => (
          <div key={index} className={styles.fieldRow}>
            <div className={styles.label}>{field.label}:</div>
            <div className={styles.value}>
              {isEditing && field.editType === 'icon-select' ? (
                <Select
                  value={editedValues[field.fieldName || ''] ?? field.value}
                  onChange={(e) => handleChange(field.fieldName || '', e.target.value)}
                  displayEmpty
                  fullWidth
                >
                  {field.options?.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.icon && <span style={{ marginRight: '8px' }}>{option.icon}</span>}
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              ) : isEditing && field.editType === 'text' ? (
                <input
                  type="text"
                  value={editedValues[field.fieldName || ''] ?? field.value}
                  onChange={(e) => handleChange(field.fieldName || '', e.target.value)}
                  style={{ width: '100%' }}
                />
              ) : isEditing && field.editType === 'status-select' ? (
                <Select
                  value={editedValues[field.fieldName]?.value ?? field.value}
                  onChange={(e) => handleChange(field.fieldName, e.target.value)}
                  displayEmpty
                  fullWidth
                >
                  {field.options?.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>

              )
                : isEditing && field.editType === 'number' ? (
                  <input
                    type="number"
                    value={editedValues[field.fieldName || ''] ?? field.value}
                    onChange={(e) => handleChange(field.fieldName || '', e.target.value)}
                    style={{ width: '100%' }}
                  />
                ) : isEditing && field.editType === 'date' ? (
                  <input
                    type="date"
                    value={convertToInputDateValue(editedValues[field.fieldName || ''] ?? field.value)}
                    onChange={(e) =>
                      handleChange(field.fieldName || '', convertFromInputDateValue(e.target.value))
                    }
                    style={{ width: '100%' }}
                  />
                ) : field.editType === 'icon-select' && field.options ? (
                  <>
                    {field.options.find((opt) => opt.value === field.value)?.icon && (
                      <span style={{ marginRight: '8px' }}>
                        {field.options.find((opt) => opt.value === field.value)?.icon}
                      </span>
                    )}
                    {field.options.find((opt) => opt.value === field.value)?.label || field.value}
                  </>
                ) : field.editType === 'date' && typeof field.value === 'string' ? (
                  field.value
                ) : (
                  field.value
                )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};











export default GenericInfo;

// import React, { useEffect, useState } from 'react';
// import styles from './GenericInfo.module.css';
// import { IconButton, MenuItem, Select } from '@mui/material';
// import EditIcon from '@mui/icons-material/Edit';
// import SaveIcon from '@mui/icons-material/Save';
// import CloseIcon from '@mui/icons-material/Close';
// import DeleteIcon from '@mui/icons-material/Delete';
// export interface InfoField {
//   label: string;
//   value: any;
//   fieldName?: string;
//   editType?: 'text' | 'icon-select' | 'select' | 'date';
//   options?: { value: string; label?: string; icon?: React.ReactNode }[];
// }
// interface GenericInfoProps {
//   title?: string;
//   fields: InfoField[];
//   onFieldsUpdate?: (updatedFields: InfoField[]) => void;
//   onSubmit: (updatedObject: any) => void;
//   onDelete?: () => void;
//   setRef?: React.Dispatch<React.SetStateAction<boolean>>;
//   fieldsContainerClassName?: string; //
// }
// const GenericInfo: React.FC<GenericInfoProps> = ({ title, fields, onFieldsUpdate, onSubmit, fieldsContainerClassName,onDelete }) => {
//   const [isEditing, setIsEditing] = useState(false);
//   const [editedValues, setEditedValues] = useState<{ [key: string]: any }>({});
//   // עדכון הערכים הערוכים כאשר fields משתנים או כאשר נכנסים למצב עריכה
//   useEffect(() => {
//     const initialValues: { [key: string]: any } = {};
//     fields.forEach((field) => {
//       if (field.fieldName) {
//         initialValues[field.fieldName] = field.value;
//       }
//     });
//     setEditedValues(initialValues);
//     // setRef(true)
//   }, [fields]); // הוספתי isEditing כדי לעדכן כאשר נכנסים למצב עריכה
//   const handleChange = (fieldName: string, value: any) => {
//     setEditedValues((prev) => ({ ...prev, [fieldName]: value }));
//   };
//   // ממיר מ-DD/MM/YYYY לפורמט של input מסוג date (YYYY-MM-DD)
//  const convertToInputDateValue = (ddmmyyyy: string): string => {
//   if (!ddmmyyyy || typeof ddmmyyyy !== 'string') return '';
//   const parts = ddmmyyyy.split('/');
//   if (parts.length !== 3) return '';
//   const [day, month, year] = parts;
//   if (!day || !month || !year) return '';
//   return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
// };
//   // ממיר מ-YYYY-MM-DD בחזרה ל-DD/MM/YYYY
//  const convertFromInputDateValue = (yyyymmdd: string): string => {
//   if (!yyyymmdd || typeof yyyymmdd !== 'string') return '';
//   const parts = yyyymmdd.split('-');
//   if (parts.length !== 3) return '';
//   const [year, month, day] = parts;
//   if (!day || !month || !year) return '';
//   return `${day}/${month}/${year}`;
// };
//   const handleSubmit = async () => {
//     try {
//       console.log('Submit clicked. Edited values:', editedValues);
//       if (onFieldsUpdate) {
//         const updatedFieldObjects = fields.map((field) => ({
//           ...field,
//           value: editedValues[field.fieldName || ''] ?? field.value,
//         }));
//         console.log('Calling onFieldsUpdate with:', updatedFieldObjects);
//         onFieldsUpdate(updatedFieldObjects);
//       }
//       const fullValues: { [key: string]: any } = {};
//       fields.forEach((field) => {
//         if (field.fieldName) {
//           fullValues[field.fieldName] = editedValues[field.fieldName] ?? field.value;
//         }
//       });
//       console.log('Calling onSubmit with:', fullValues);
//       await onSubmit(fullValues);
//       // window.location.reload();
//       // מרענן את העמוד הנוכחי
//       // setRef(true)
//       setIsEditing(false);
//     } catch (err) {
//       console.error('שגיאה בעדכון הנתונים:', err);
//     }
//   };
//   // פונקציה לביטול העריכה
//   const handleCancel = () => {
//     // החזרת הערכים למצב המקורי
//     const initialValues: { [key: string]: any } = {};
//     fields.forEach((field) => {
//       if (field.fieldName) {
//         initialValues[field.fieldName] = field.value;
//       }
//     });
//     setEditedValues(initialValues);
//     setIsEditing(false);
//   };
//   return (
//     <div className={styles.container}>
//       <div className={styles.titleRow}>
//         <h3 className={styles.title}>{title}</h3>
//         <div className={styles.actions}>
//          {onDelete && (
//         <IconButton onClick={onDelete} title="מחיקה">
//           <DeleteIcon style={{ color: 'red' }} />
//         </IconButton>
//       )}
//           {!isEditing ? (
//             <IconButton onClick={() => setIsEditing(true)}>
//               <EditIcon />
//             </IconButton>
//           ) : (
//             <>
//               <IconButton onClick={handleSubmit}>
//                 <SaveIcon />
//               </IconButton>
//               <IconButton onClick={handleCancel}>
//                 <CloseIcon />
//               </IconButton>
//             </>
//           )}
//         </div>
//       </div>
//       <div className={`${styles.grid} ${fieldsContainerClassName || ''}`}>
//         {fields.map((field, index) => (
//           <div key={index} className={styles.fieldRow}>
//             <div className={styles.label}>{field.label}:</div>
//             <div className={styles.value}>
//               {isEditing && field.editType === 'icon-select' ? (
//                 <Select
//                   value={editedValues[field.fieldName || ''] ?? field.value}
//                   onChange={(e) => handleChange(field.fieldName || '', e.target.value)}
//                   displayEmpty
//                   fullWidth
//                 >
//                   {field.options?.map((option) => (
//                     <MenuItem key={option.value} value={option.value}>
//                       {option.icon && <span style={{ marginRight: '8px' }}>{option.icon}</span>}
//                       {option.label}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               ) : isEditing && field.editType === 'text' ? (
//                 <input
//                   type="text"
//                   value={editedValues[field.fieldName || ''] ?? field.value}
//                   onChange={(e) => handleChange(field.fieldName || '', e.target.value)}
//                   style={{ width: '100%' }}
//                 />
//               ) : isEditing && field.editType === 'date' ? (
//                 <input
//                   type="date"
//                   value={convertToInputDateValue(editedValues[field.fieldName || ''] ?? field.value)}
//                   onChange={(e) =>
//                     handleChange(field.fieldName || '', convertFromInputDateValue(e.target.value))
//                   }
//                   style={{ width: '100%' }}
//                 />
// ) : field.editType === 'icon-select' && field.options ? (
//   <>
//     {field.options.find((opt) => opt.value === field.value)?.icon && (
//       <span style={{ marginRight: '8px' }}>
//         {field.options.find((opt) => opt.value === field.value)?.icon}
//       </span>
//     )}
//     {field.options.find((opt) => opt.value === field.value)?.label || field.value}
//   </>
// ) : field.editType === 'date' && typeof field.value === 'string' ? (
//                 field.value // כבר DD/MM/YYYY
//               ) : (
//                 field.value
//               )}
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };
// export default GenericInfo;